export default __webpack_public_path__ + "static/media/healthInsurance_final.3eb3e435.jpg";